"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getDocumentLocale = getDocumentLocale;
/**
 * Retrieves the locale from the document's data attribute.
 *
 * @returns {string | undefined} - The locale code if available, otherwise undefined.
 */
function getDocumentLocale() {
  return document.documentElement.dataset.locale;
}